import { Component, OnInit } from '@angular/core';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';

declare const gapi: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  auth2 : any;
  loading = false;
  constructor(
    private userService: UsuarioService
  ) { }

  ngOnInit(): void {
    this.googleInit();
    //validateUserLogeado
    let data = this.userService.getLocalStorage();
    this.validateUser(data);
  }

  googleInit(){

    gapi.load('auth2', () => {

      this.auth2 = gapi.auth2.init({
        client_id: '304638218270-hnglicvp17nvfudd687rkbnmr36n1oik.apps.googleusercontent.com',
        cookiepolicy: 'single_host_origin',
        scope: 'profile email'
      })

      this.attachSignin( document.getElementById('btnGoogle') );
    });

  }

  validateUser(data){
    if(data['user'] != null && data['token'].length > 5){
      if(data['user']['terminos']){
        window.location.href = "#/dashboard";
      }else{
        window.location.href = "#/terms";
      }
    }
  }

  attachSignin( element ){
    

    this.auth2.attachClickHandler( element, {}, (googleUser) => {
      this.loading = true;
      let id_token = googleUser.getAuthResponse().id_token;
      //validate Token
      this.signInUser(id_token);
    } );

  }

  signInUser( token ){
    this.userService.sendLoginToken( token ).subscribe(res =>{
      if( res['status'] === 'success' ){
        this.saveLocalstorage( res );
      }else{
      }
    }, error => {  });
  }

  saveLocalstorage( data ){
    data['user_db']['terminos'] = data['terminos'];
    let user = data['user_db'];
    let token = data['token']['access_token'];

    this.userService.saveLocalStorage( user, token );
    this.loading = false;
    if(user['terminos']){
      window.location.href = "#/dashboard";
    }else{
      window.location.href = "#/terms";
     
    }
  }

}
